export default __webpack_public_path__ + "static/media/referral-sunglass.d939e015.png";